export default [
  {
    grbsCode: '005000',
    grbsName: '005000. Министерство агропромышленного комплекса и потребительского рынка Свердловской области',
    credentials: [
      {
        credentialCode: '324001',
        credentialName:
          '324001. Улучшение жилищных условий граждан, проживающих в сельской местности, в том числе молодых семей и молодых специалистов',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem: '0520245762. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '11 472,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '11 472,30',
              },
              {
                targetItem: '0520245762. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '32 794,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '32 794,10',
              },
              {
                targetItem: '0520245762. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '19 606,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '19 606,60',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '46 956,20',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '46 956,20',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '4 681,50',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '4 681,50',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '18 951,90',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '18 951,90',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '23 127,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '23 127,70',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 305,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '2 305,90',
              },
              {
                targetItem: '05202R5760. Улучшение жилищных условий граждан, проживающих на сельских терр',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1285-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '8 122,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '8 122,30',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '008000',
    grbsName: '008000. Министерство строительства и развития инфраструктуры Свердловской области',
    credentials: [
      {
        credentialCode: '324002',
        credentialName: '324002. Предоставление социальных выплат молодым семьям на приобретение (строительство) жилья',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '21 093,70',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '21 093,70',
              },
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '17 565,20',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '17 565,20',
              },
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '18 950,60',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'плановый метод',
                estimatedAmount: '18 950,60',
              },
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '97 855,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '97 855,40',
              },
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '97 855,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '97 855,40',
              },
              {
                targetItem: '08108R4970. Предоставление социальных выплат молодым семьям на приобретение ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '87 363,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '87 363,90',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '324004',
        credentialName:
          '324004. Предоставление региональных социальных выплат молодым семьям на улучшение жилищных условий',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem: '0810949500. Предоставление региональных социальных выплат молодым семьям на ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '3 039,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '3 039,50',
              },
              {
                targetItem: '0810949500. Предоставление региональных социальных выплат молодым семьям на ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '3 039,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '3 039,50',
              },
              {
                targetItem: '0810949500. Предоставление региональных социальных выплат молодым семьям на ',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'абз. 5 п. 1 ст. 26.14',
                regionalAct: '1296-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '3 039,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '3 039,50',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '012000',
    grbsName: '012000. Мин-во образования и молодежной политики СО',
    credentials: [
      {
        credentialCode: '1061',
        credentialName:
          '1061. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки льготным категориям граждан)',
        fkrs: [
          {
            fkrCode: '0702',
            fkrName: '0702. Общее образование',
            rows: [
              {
                targetItem:
                  '1221113000. Организация предоставления общего образования и создание условий для содержания детей в государственных общеобразовательных организациях',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '652,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '652,80',
              },
              {
                targetItem:
                  '1221113000. Организация предоставления общего образования и создание условий для содержания детей в государственных общеобразовательных организациях',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '17 672,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '17 672,40',
              },
              {
                targetItem:
                  '1221113000. Организация предоставления общего образования и создание условий для содержания детей в государственных общеобразовательных организациях',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '18 408,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '18 408,40',
              },
              {
                targetItem:
                  '1221113000. Организация предоставления общего образования и создание условий для содержания детей в государственных общеобразовательных организациях',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '18 494,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '18 494,90',
              },
            ],
          },
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem: '1221117000. Компенсация за питание обучающихся с ограниченными возможностями',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '29 903,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '29 903,30',
              },
              {
                targetItem: '1221117000. Компенсация за питание обучающихся с ограниченными возможностями',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '31 099,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '31 099,40',
              },
              {
                targetItem: '1221117000. Компенсация за питание обучающихся с ограниченными возможностями',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '32 343,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '32 343,40',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1063',
        credentialName:
          '1063. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки детям-сиротам, безнадзорным детям, детям, оставшимся без попечения родителей)',
        fkrs: [
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem: '1220513000. Предоставление социальных услуг и создание условий для содержани',
                expenseType: '611',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '83 541,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '83 541,00',
              },
              {
                targetItem:
                  '1222117000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '372 018,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '372 018,50',
              },
              {
                targetItem:
                  '1222117000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '386 899,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '386 899,20',
              },
              {
                targetItem:
                  '1222117000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '402 375,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '402 375,20',
              },
              {
                targetItem:
                  '1233617000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях, реализующих программы педагогического образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '27 988,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '27 988,50',
              },
              {
                targetItem:
                  '1233617000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях, реализующих программы педагогического образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '29 108,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '29 108,00',
              },
              {
                targetItem:
                  '1233617000. Обеспечение социальной поддержки детей-сирот и детей, оставшихся без попечения родителей, обучающихся в государственных профессиональных образовательных организациях, реализующих программы педагогического образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '30 272,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '30 272,30',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '321030',
        credentialName:
          '321030. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки детям-сиротам, безнадзорным детям, детям, оставшимся без попечения родителей)',
        fkrs: [
          {
            fkrCode: '0702',
            fkrName: '0702. Общее образование',
            rows: [
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '107 912,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '107 912,00',
              },
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '112 227,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '112 227,00',
              },
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '116 722,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '116 722,00',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '610002',
        credentialName: '610002. Мероприятия по организации питания в общеобразовательных учреждениях',
        fkrs: [
          {
            fkrCode: '0702',
            fkrName: '0702. Общее образование',
            rows: [
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 900 815,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 900 815,00',
              },
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 976 848,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 976 848,00',
              },
              {
                targetItem:
                  '1221545400. Осуществление мероприятий по обеспечению питанием обучающихся в муниципальных общеобразовательных организациях',
                expenseType: '521',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 055 910,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 055 910,00',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '610003',
        credentialName:
          '610003. Обеспечение выплаты пособий детям-сиротам и детям, оставшимся без попечения родителей, лицам из числа детей-сирот и детей, оставшихся без попечения родителей, лицам, потерявшим в период обучения обоих родителей или единственного родителя, обучающимся по очной форме обучения по образовательным программам за счет средств местных бюджетов муниципальных образований',
        fkrs: [
          {
            fkrCode: '0709',
            fkrName: '0709. Другие вопросы в области образования',
            rows: [
              {
                targetItem:
                  '1225545200. Обеспечение дополнительных гарантий по социальной поддержке детей-сирот и детей, оставшихся без попечения родителей, лиц из числа детей-сирот и детей, оставшихся без попечения родителей, лиц, потерявших в период обучения обоих родителей или единственного родителя, обучающихся в муниципальных образовательных организациях',
                expenseType: '540',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '29 502,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '29 502,20',
              },
              {
                targetItem:
                  '1225545200. Обеспечение дополнительных гарантий по социальной поддержке детей-сирот и детей, оставшихся без попечения родителей, лиц из числа детей-сирот и детей, оставшихся без попечения родителей, лиц, потерявших в период обучения обоих родителей или единственного родителя, обучающихся в муниципальных образовательных организациях',
                expenseType: '540',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '30 682,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '30 682,30',
              },
              {
                targetItem:
                  '1225545200. Обеспечение дополнительных гарантий по социальной поддержке детей-сирот и детей, оставшихся без попечения родителей, лиц из числа детей-сирот и детей, оставшихся без попечения родителей, лиц, потерявших в период обучения обоих родителей или единственного родителя, обучающихся в муниципальных образовательных организациях',
                expenseType: '540',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: 'не указан',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '31 909,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'метод индексации',
                estimatedAmount: '31 909,60',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '013000',
    grbsName: '013000. Министерство здравоохранения Свердловской области',
    credentials: [
      {
        credentialCode: '1061',
        credentialName:
          '1061. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки льготным категориям граждан)',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '930,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '930,00',
              },
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '967,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '967,20',
              },
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 005,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 005,90',
              },
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '612',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '3 890,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '3 890,30',
              },
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '612',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '4 045,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '4 045,90',
              },
              {
                targetItem:
                  '1370817000. Меры социальной поддержки по обеспечению отдельных категорий граждан протезно-ортопедическими изделиями в соответствии с Законом Свердловской области «Об охране здоровья граждан в Свердловской области»',
                expenseType: '612',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '4 207,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '4 207,70',
              },
              {
                targetItem:
                  '1371017000. Обеспечение бесплатного изготовления и ремонта зубных протезов отдельным категориям ветеранов в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '305 350,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '305 350,20',
              },
              {
                targetItem:
                  '1371017000. Обеспечение бесплатного изготовления и ремонта зубных протезов отдельным категориям ветеранов в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '317 564,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '317 564,20',
              },
              {
                targetItem:
                  '1371017000. Обеспечение бесплатного изготовления и ремонта зубных протезов отдельным категориям ветеранов в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '330 266,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '330 266,80',
              },
              {
                targetItem: '1371117000. Обеспечение бесплатного изготовления и ремонта зубных протезов т',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '7 323,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 323,70',
              },
              {
                targetItem: '1371117000. Обеспечение бесплатного изготовления и ремонта зубных протезов т',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '7 616,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 616,60',
              },
              {
                targetItem: '1371117000. Обеспечение бесплатного изготовления и ремонта зубных протезов т',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '7 921,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 921,30',
              },
              {
                targetItem:
                  '1371217000. Обеспечение бесплатного изготовления и ремонта зубных протезов в соответствии с Законом Свердловской области «О социальной поддержке реабилитированных лиц и лиц, признанных пострадавшими от политических репрессий, в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '7 619,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 619,20',
              },
              {
                targetItem:
                  '1371217000. Обеспечение бесплатного изготовления и ремонта зубных протезов в соответствии с Законом Свердловской области «О социальной поддержке реабилитированных лиц и лиц, признанных пострадавшими от политических репрессий, в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '7 924,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 924,00',
              },
              {
                targetItem:
                  '1371217000. Обеспечение бесплатного изготовления и ремонта зубных протезов в соответствии с Законом Свердловской области «О социальной поддержке реабилитированных лиц и лиц, признанных пострадавшими от политических репрессий, в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '8 241,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '8 241,00',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1062',
        credentialName:
          '1062. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки гражданам по установленным критериям нуждаемости (за исключением поддержки льготных категорий граждан))',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem:
                  '137P117060. Меры социальной поддержки проживающих в Свердловской области беременных женщин, кормящих матерей, детей в возрасте до трех лет по обеспечению полноценным питанием, детей, страдающих фенилкетонурией, галактоземией, лейцинозом, адренолейкодистрофией, тяжелыми формами пищевой аллергии с непереносимостью белков коровьего молока, и детей с экстремально низкой массой при рождении специализированными продуктами лечебного питания',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '450 010,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '450 010,00',
              },
              {
                targetItem:
                  '137P117060. Меры социальной поддержки проживающих в Свердловской области беременных женщин, кормящих матерей, детей в возрасте до трех лет по обеспечению полноценным питанием, детей, страдающих фенилкетонурией, галактоземией, лейцинозом, адренолейкодистрофией, тяжелыми формами пищевой аллергии с непереносимостью белков коровьего молока, и детей с экстремально низкой массой при рождении специализированными продуктами лечебного питания',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '450 010,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '450 010,00',
              },
              {
                targetItem:
                  '137P117060. Меры социальной поддержки проживающих в Свердловской области беременных женщин, кормящих матерей, детей в возрасте до трех лет по обеспечению полноценным питанием, детей, страдающих фенилкетонурией, галактоземией, лейцинозом, адренолейкодистрофией, тяжелыми формами пищевой аллергии с непереносимостью белков коровьего молока, и детей с экстремально низкой массой при рождении специализированными продуктами лечебного питания',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '450 010,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '450 010,00',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1063',
        credentialName:
          '1063. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки детям-сиротам, безнадзорным детям, детям, оставшимся без попечения родителей)',
        fkrs: [
          {
            fkrCode: '0909',
            fkrName: '0909. Другие вопросы в области здравоохранения',
            rows: [
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '380 810,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '380 810,30',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '400 803,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '400 803,40',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '423 783,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '423 783,10',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '144,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '144,60',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '150,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '150,40',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '156,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '156,40',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '115 004,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '115 004,70',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '121 042,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '121 042,60',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '127 982,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '127 982,50',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '21 013,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '21 013,90',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '21 854,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '21 854,50',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '22 728,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '22 728,70',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '85 747,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '85 747,10',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '89 177,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '89 177,00',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '92 744,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '92 744,10',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '6 686,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '6 686,20',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '6 953,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '6 953,60',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '7 231,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '7 231,70',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '224,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '224,00',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '233,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '233,00',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '242,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '242,30',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '211,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '211,90',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '220,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '220,40',
              },
              {
                targetItem:
                  '1330413000. Финансовое обеспечение деятельности организаций круглосуточного пребывания детей',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '229,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'плановый метод',
                estimatedAmount: '229,20',
              },
            ],
          },
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem:
                  '1390417000. Предоставление детям-сиротам и детям, оставшимся без попечения родителей, мер социальной поддержки',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '45 319,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '45 319,10',
              },
              {
                targetItem:
                  '1390417000. Предоставление детям-сиротам и детям, оставшимся без попечения родителей, мер социальной поддержки',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '44 140,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '44 140,40',
              },
              {
                targetItem:
                  '1390417000. Предоставление детям-сиротам и детям, оставшимся без попечения родителей, мер социальной поддержки',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1267-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '18 300,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '18 300,50',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '014000',
    grbsName: '014000. Министерство культуры Свердловской области',
    credentials: [
      {
        credentialCode: '1063',
        credentialName:
          '1063. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки детям-сиротам, безнадзорным детям, детям, оставшимся без попечения родителей)',
        fkrs: [
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem: '1424313000. Организация предоставления среднего профессионального образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1268-ПП',
                regionalActDetails: 'п.1',
                year: '2020',
                periodType: 'план',
                actualAmount: '6 102,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 102,00',
              },
              {
                targetItem: '1424313000. Организация предоставления среднего профессионального образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1268-ПП',
                regionalActDetails: 'п.1',
                year: '2021',
                periodType: 'план',
                actualAmount: '6 102,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 102,00',
              },
              {
                targetItem: '1424313000. Организация предоставления среднего профессионального образования',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '1268-ПП',
                regionalActDetails: 'п.1',
                year: '2022',
                periodType: 'план',
                actualAmount: '6 102,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 102,00',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '015000',
    grbsName: '015000. Министерство социальной политики Свердловской области',
    credentials: [
      {
        credentialCode: '1060',
        credentialName:
          '1060. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части  обеспечения деятельности организаций социального обслуживания субъекта Российской Федерации)',
        fkrs: [
          {
            fkrCode: '1002',
            fkrName: '1002. Социальное обслуживание населения',
            rows: [
              {
                targetItem: '1510116000. Осуществление капитальных вложений в объекты государственной соб',
                expenseType: '414',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '11 600,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '11 600,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '277 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '277 000,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '288 080,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '288 080,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '299 603,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '299 603,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '400,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '400,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '400,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '83 654,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '83 654,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '87 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '87 000,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '90 480,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '90 480,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '13 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '13 000,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '15 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '15 000,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '500,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '94 115,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '94 115,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '101 389,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '101 389,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '84 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '84 500,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '611',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '18 895,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '18 895,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '611',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '19 614,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '19 614,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '611',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '20 548,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '20 548,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 296 393,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 296 393,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 325 017,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 325 017,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 388 114,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 388 114,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '66 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '66 000,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 350,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 350,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 300,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 300,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 300,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 300,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '50,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '50,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '50,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '50,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '50,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '50,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '30,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '30,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30,00',
              },
              {
                targetItem:
                  '1510413000. Оказание услуг (выполнение работ) по социальному обслуживанию в стационарной форме',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '30,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '559 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '559 000,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '587 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '587 000,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '111',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '616 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '616 500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '850,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '850,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '850,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '850,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '112',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '850,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '850,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '168 818,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '168 818,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '177 274,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '177 274,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '119',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '186 183,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '186 183,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '4 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '4 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '243',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '287 397,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '287 397,90',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '303 868,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '303 868,50',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '286 737,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '286 737,20',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '500,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '100,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '100,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '100,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '100,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '100,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '100,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '611',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '66 188,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '66 188,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '611',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '68 709,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '68 709,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '611',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '71 981,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '71 981,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '621',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 495 841,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 495 841,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '621',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 552 825,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 552 825,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '621',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 626 769,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 626 769,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '831',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '25,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '25,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '831',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '25,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '25,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '831',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '25,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '25,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '11 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '11 000,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '11 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '11 000,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '851',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '11 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '11 000,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '150,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '150,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '150,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '150,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '852',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '150,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '150,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '800,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '800,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '800,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '800,00',
              },
              {
                targetItem: '1510513000. Предоставление социального обслуживания семьям с детьми',
                expenseType: '853',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '800,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '800,00',
              },
              {
                targetItem: '1510610000. Укрепление материально-технической базы организаций социального',
                expenseType: '612',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '5 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 000,00',
              },
              {
                targetItem: '1510610000. Укрепление материально-технической базы организаций социального',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '216 396,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '216 396,80',
              },
              {
                targetItem: '1510610000. Укрепление материально-технической базы организаций социального',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '169 094,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '169 094,40',
              },
              {
                targetItem: '1510610000. Укрепление материально-технической базы организаций социального',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '148 369,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '148 369,70',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '111',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '22 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '22 000,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '111',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '22 880,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '22 880,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '111',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '24 100,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '24 100,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '112',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '75,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '75,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '112',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '75,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '75,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '112',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '75,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '75,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '119',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '6 644,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 644,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '119',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '6 910,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 910,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '119',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '7 278,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 278,20',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '2 700,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 700,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 727,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 727,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 700,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 700,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '3 087 090,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '3 087 090,80',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '3 194 157,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '3 194 157,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '621',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '3 346 925,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '3 346 925,20',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '30 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30 500,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '632',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '82 585,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '82 585,20',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '632',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '85 888,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '85 888,60',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '632',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '89 324,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '89 324,00',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '851',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '16,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '16,50',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '851',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '16,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '16,50',
              },
              {
                targetItem:
                  '1510913000. Предоставление социального обслуживания гражданам пожилого возраста, инвалидам и лицам, попавшим в трудную жизненную ситуацию',
                expenseType: '851',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '16,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '16,50',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1061',
        credentialName:
          '1061. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки льготным категориям граждан)',
        fkrs: [
          {
            fkrCode: '1002',
            fkrName: '1002. Социальное обслуживание населения',
            rows: [
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '631',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '6 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 000,00',
              },
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '631',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 800,00',
              },
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '631',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 600,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 600,00',
              },
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '16 351,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '16 351,00',
              },
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 600,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 600,00',
              },
              {
                targetItem: '1510810000. Выплата компенсации поставщику или поставщикам социальных услуг,',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 000,00',
              },
            ],
          },
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem: '1533117079. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '382 645,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '382 645,60',
              },
              {
                targetItem: '1533117079. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '440 582,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '440 582,80',
              },
              {
                targetItem: '1533117079. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '440 582,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '440 582,80',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '28 142,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '28 142,50',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '30 361,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30 361,80',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '30 361,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '30 361,80',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2-1 ч. 1 ст. 9, подп. 2-1 ч. 1 ст. 11',
                year: '2020',
                periodType: 'план',
                actualAmount: '2 004 442,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 004 442,00',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2-1 ч. 1 ст. 9, подп. 2-1 ч. 1 ст. 11',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 162 520,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 162 520,10',
              },
              {
                targetItem: '1533117080. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2-1 ч. 1 ст. 9, подп. 2-1 ч. 1 ст. 11',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 162 520,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 162 520,10',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '67,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '67,70',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '36,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '36,70',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '36,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '36,70',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2020',
                periodType: 'план',
                actualAmount: '4 825,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 825,30',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 611,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 611,50',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 611,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 611,50',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2020',
                periodType: 'план',
                actualAmount: '5 846,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 846,70',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2021',
                periodType: 'план',
                actualAmount: '9 195,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '9 195,70',
              },
              {
                targetItem: '1533117081. Предоставление один раз в два календарных года при наличии медиц',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, подп. 9 ч. 1 ст. 9',
                year: '2022',
                periodType: 'план',
                actualAmount: '9 195,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '9 195,70',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '12 443,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '12 443,60',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '13 691,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '13 691,40',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '13 691,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '13 691,40',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails:
                  'подп. 4 ч. 1 ст. 11, подп. 4 п. 3 ст. 7, п. 1, 2 ст. 18, п. 2 ст. 17, п. 4, 4-1, 4-2 ст. 9',
                year: '2020',
                periodType: 'план',
                actualAmount: '886 304,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '886 304,40',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails:
                  'подп. 4 ч. 1 ст. 11, подп. 4 п. 3 ст. 7, п. 1, 2 ст. 18, п. 2 ст. 17, п. 4, 4-1, 4-2 ст. 9',
                year: '2021',
                periodType: 'план',
                actualAmount: '975 173,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '975 173,50',
              },
              {
                targetItem: '1533117082. Ежемесячные пособия на пользование услугами местной телефонной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails:
                  'подп. 4 ч. 1 ст. 11, подп. 4 п. 3 ст. 7, п. 1, 2 ст. 18, п. 2 ст. 17, п. 4, 4-1, 4-2 ст. 9',
                year: '2022',
                periodType: 'план',
                actualAmount: '975 173,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '975 173,50',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, п. 5 ст. 5, п. 2 ст. 17',
                year: '2020',
                periodType: 'план',
                actualAmount: '1,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,00',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, п. 5 ст. 5, п. 2 ст. 17',
                year: '2021',
                periodType: 'план',
                actualAmount: '1,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,00',
              },
              {
                targetItem: '1533117083. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 2 ч. 1 п. 4 ст. 5, п. 5 ст. 5, п. 2 ст. 17',
                year: '2022',
                periodType: 'план',
                actualAmount: '1,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,00',
              },
              {
                targetItem: '1533117084. Обеспечение льготного проезда по территории Свердловской области',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '31 930,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '31 930,50',
              },
              {
                targetItem: '1533117084. Обеспечение льготного проезда по территории Свердловской области',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '43 007,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '43 007,70',
              },
              {
                targetItem: '1533117084. Обеспечение льготного проезда по территории Свердловской области',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '43 007,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '43 007,70',
              },
              {
                targetItem:
                  '1533117Г17. Бесплатное обеспечение при наличии медицинских показаний протезами и протезно-ортопедическими изделиями тружеников тыла в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 ст. 9',
                year: '2020',
                periodType: 'план',
                actualAmount: '298,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '298,90',
              },
              {
                targetItem:
                  '1533117Г17. Бесплатное обеспечение при наличии медицинских показаний протезами и протезно-ортопедическими изделиями тружеников тыла в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 ст. 9',
                year: '2021',
                periodType: 'план',
                actualAmount: '411,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '411,90',
              },
              {
                targetItem:
                  '1533117Г17. Бесплатное обеспечение при наличии медицинских показаний протезами и протезно-ортопедическими изделиями тружеников тыла в соответствии с Законом Свердловской области «О социальной поддержке ветеранов в Свердловской области»',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '190-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 ст. 9',
                year: '2022',
                periodType: 'план',
                actualAmount: '411,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '411,90',
              },
              {
                targetItem: '1533417078. Предоставление бесплатного проезда по территории Свердловской об',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '621-ПП',
                regionalActDetails: 'ст. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '2 686,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 686,90',
              },
              {
                targetItem: '1534717165. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '14 059,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 878,20',
              },
              {
                targetItem: '1534717165. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '15 473,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '15 473,30',
              },
              {
                targetItem: '1534717165. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '15 473,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '15 473,30',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 228,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 214,10',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 287,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 262,60',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 287,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 262,60',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 3 п. 2 ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '87 496,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '88 198,90',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 3 п. 2 ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '91 702,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '91 726,90',
              },
              {
                targetItem: '1534717230. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 3 п. 2 ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '91 702,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '91 726,90',
              },
              {
                targetItem: '1534717366. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '6 622,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 870,70',
              },
              {
                targetItem: '1534717366. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '5 065,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 065,50',
              },
              {
                targetItem: '1534717366. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '5 065,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 065,50',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '233,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '264,70',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '280,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '275,30',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '280,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '275,30',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 8 ч. 1 п. 2 ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '16 622,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '19 243,50',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 8 ч. 1 п. 2 ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '20 008,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '20 013,20',
              },
              {
                targetItem: '1534717431. Компенсация расходов на оплату проезда (туда и обратно) по терри',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 8 ч. 1 п. 2 ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '20 008,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '20 013,20',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '0,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '0,10',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 п. 2 ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '1,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,20',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 п. 2 ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '1,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,30',
              },
              {
                targetItem: '1534717532. Компенсация 100 процентов расходов на оплату по действующим тари',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'подп. 5 ч. 1 п. 2 ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '1,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1,30',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '790,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '991,30',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 036,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 031,00',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 036,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 031,00',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'ч. 3 п. 2 ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '56 286,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '71 031,70',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'ч. 3 п. 2 ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '73 868,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '73 873,00',
              },
              {
                targetItem: '1534717633. Компенсация расходов на оплату услуг по погребению в соответстви',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '191-ОЗ',
                regionalActDetails: 'ч. 3 п. 2 ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '73 868,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '73 873,00',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '307,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '493,00',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '512,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '513,00',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '512,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '513,00',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2020',
                periodType: 'план',
                actualAmount: '22 201,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '35 666,50',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2021',
                periodType: 'план',
                actualAmount: '37 093,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '37 092,90',
              },
              {
                targetItem: '1539217271. Социальное пособие реабилитированным лицам и лицам, признанным п',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2022',
                periodType: 'план',
                actualAmount: '37 093,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '37 092,90',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '7,30',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2,10',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '2,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2,30',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '2,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2,30',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2020',
                periodType: 'план',
                actualAmount: '498,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '498,00',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2021',
                periodType: 'план',
                actualAmount: '135,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '135,00',
              },
              {
                targetItem: '1539217372. Оказание государственной социальной помощи на основании социальн',
                expenseType: '321',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2022',
                periodType: 'план',
                actualAmount: '135,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '135,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '34,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '44,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '45,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '46,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '45,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '46,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2020',
                periodType: 'план',
                actualAmount: '3 906,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 903,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2021',
                periodType: 'план',
                actualAmount: '5 099,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 098,00',
              },
              {
                targetItem: '1539217473. Материальная помощь гражданам, находящимся в трудной жизненной с',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2022',
                periodType: 'план',
                actualAmount: '5 099,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 098,00',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 099,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 099,60',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '572,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '573,00',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '572,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '573,00',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'пп.2 ст.3, ст. 12',
                year: '2020',
                periodType: 'план',
                actualAmount: '79 040,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '79 040,00',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'пп.2 ст.3, ст. 12',
                year: '2021',
                periodType: 'план',
                actualAmount: '41 474,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '41 473,00',
              },
              {
                targetItem: '1539217575. Компенсации отдельным категориям граждан затрат на приобретение',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'пп.2 ст.3, ст. 12',
                year: '2022',
                periodType: 'план',
                actualAmount: '41 474,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '41 473,00',
              },
              {
                targetItem: '1539217668. Компенсация отдельным категориям граждан затрат на приобретение ',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '138,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '138,00',
              },
              {
                targetItem: '1539217668. Компенсация отдельным категориям граждан затрат на приобретение ',
                expenseType: '323',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'подп. 3 ст. 3',
                year: '2020',
                periodType: 'план',
                actualAmount: '9 862,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '9 862,00',
              },
            ],
          },
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 000,00',
              },
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 000,00',
              },
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 000,00',
              },
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '116-ОЗ',
                regionalActDetails: 'абз. 2 ст. 3',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 633 077,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 633 077,90',
              },
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '116-ОЗ',
                regionalActDetails: 'абз. 2 ст. 3',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 700 242,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 700 242,60',
              },
              {
                targetItem: '1540517120. Вознаграждение приемным родителям в соответствии с Законом Сверд',
                expenseType: '323',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '116-ОЗ',
                regionalActDetails: 'абз. 2 ст. 3',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 700 242,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 700 242,60',
              },
              {
                targetItem:
                  '1541910000. Перевозка в пределах территории Свердловской области несовершеннолетних, самовольно ушедших из семей, детских домов, школ-интернатов, специальных учебно-воспитательных и иных детских учреждений',
                expenseType: '622',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '22,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '22,80',
              },
              {
                targetItem:
                  '1541910000. Перевозка в пределах территории Свердловской области несовершеннолетних, самовольно ушедших из семей, детских домов, школ-интернатов, специальных учебно-воспитательных и иных детских учреждений',
                expenseType: '622',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '24,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '24,90',
              },
              {
                targetItem:
                  '1541910000. Перевозка в пределах территории Свердловской области несовершеннолетних, самовольно ушедших из семей, детских домов, школ-интернатов, специальных учебно-воспитательных и иных детских учреждений',
                expenseType: '622',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '24,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '24,90',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '17 500,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '17 500,00',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '20 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '20 000,00',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '20 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '20 000,00',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '107-ОЗ',
                regionalActDetails: 'ч. 1 ст. 6',
                year: '2020',
                periodType: 'план',
                actualAmount: '2 084 259,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 084 259,80',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '107-ОЗ',
                regionalActDetails: 'ч. 1 ст. 6',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 455 041,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 455 041,70',
              },
              {
                targetItem: '1547917117. Выплаты в соответствии с Законом Свердловской области «О денежны',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '107-ОЗ',
                regionalActDetails: 'ч. 1 ст. 6',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 455 041,70',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 455 041,70',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '222,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '222,00',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '202,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '180,00',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '202,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '180,00',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'ч. первая п. 1-2 ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '15 857,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '15 857,00',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'ч. первая п. 1-2 ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '14 398,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 398,00',
              },
              {
                targetItem: '1549117023. Компенсация расходов на приобретение комплекта одежды для посеще',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'ч. первая п. 1-2 ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '14 398,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 398,00',
              },
              {
                targetItem: '1549117111. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '13 892,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '13 768,40',
              },
              {
                targetItem: '1549117111. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '14 318,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 318,50',
              },
              {
                targetItem: '1549117111. Обеспечение бесплатного проезда по территории Свердловской облас',
                expenseType: '811',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '14 318,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 318,50',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '7 326,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 771,00',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '6 110,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 001,90',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '6 110,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '6 001,90',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1 п. 1  ст. 2',
                year: '2020',
                periodType: 'план',
                actualAmount: '521 919,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '418 695,00',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1 п. 1  ст. 2',
                year: '2021',
                periodType: 'план',
                actualAmount: '435 335,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '435 443,10',
              },
              {
                targetItem: '1549117212. Ежемесячное пособие на проезд по территории Свердловской области',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1 п. 1  ст. 2',
                year: '2022',
                periodType: 'план',
                actualAmount: '435 335,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '435 443,10',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '14 031,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 031,20',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '14 036,50',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 036,50',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '14 046,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '14 046,90',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '78-ОЗ',
                regionalActDetails: 'ст. 23',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 018 426,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 018 426,60',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '78-ОЗ',
                regionalActDetails: 'ст. 23',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 018 180,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 018 180,20',
              },
              {
                targetItem:
                  '154P117115. Компенсация платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, в соответствии с Законом Свердловской области «Об образовании в Свердловской области»',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '78-ОЗ',
                regionalActDetails: 'ст. 23',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 018 940,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 018 940,10',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '30 271,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '38 680,00',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '31 158,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '40 227,00',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '31 158,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '40 227,00',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2020',
                periodType: 'план',
                actualAmount: '1 156 864,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 870 714,00',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 136 019,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 933 888,80',
              },
              {
                targetItem: '154P117313. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 205 510,60',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '1 933 888,80',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2020',
                periodType: 'план',
                actualAmount: '2 029 653,40',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 029 653,40',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2021',
                periodType: 'план',
                actualAmount: '2 200 357,20',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 200 357,20',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '00101',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2022',
                periodType: 'план',
                actualAmount: '2 366 486,20',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 366 486,20',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2020',
                periodType: 'план',
                actualAmount: '999 680,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '285 830,20',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2021',
                periodType: 'план',
                actualAmount: '1 083 700,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '285 830,20',
              },
              {
                targetItem: '154P150840. Ежемесячная денежная выплата семьям на третьего или последующих ',
                expenseType: '313',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '100-ОЗ',
                regionalActDetails: 'подп. 1-1 ст.2',
                year: '2022',
                periodType: 'план',
                actualAmount: '1 014 208,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '285 830,20',
              },
            ],
          },
          {
            fkrCode: '1006',
            fkrName: '1006. Другие вопросы в области социальной политики',
            rows: [
              {
                targetItem:
                  '1536310000. Организация и проведение межрегиональной специализированной выставки «Социальная поддержка и реабилитация лиц с ограниченными возможностями здоровья. Технические средства, технологии, услуги»',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '200,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '200,00',
              },
              {
                targetItem:
                  '1536310000. Организация и проведение межрегиональной специализированной выставки «Социальная поддержка и реабилитация лиц с ограниченными возможностями здоровья. Технические средства, технологии, услуги»',
                expenseType: '350',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '233-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '840,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '840,00',
              },
              {
                targetItem:
                  '1551315140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '9 400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '2 403,40',
              },
              {
                targetItem:
                  '1551315140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '9 400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '9 400,00',
              },
              {
                targetItem:
                  '1551315140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '9 400,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '9 400,00',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '00100',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '12 042,10',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '12 042,10',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '00100',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '12 042,10',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '12 042,10',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '00100',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '12 042,10',
                sourceOfFinancing: 'федеральный бюджет',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '12 042,10',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '5 931,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 931,20',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '5 931,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 931,20',
              },
              {
                targetItem:
                  '15513R5140. Формирование и совершенствование системы комплексной реабилитации и абилитации инвалидов, в том числе детей-инвалидов, в Свердловской области на условиях софинансирования из федерального бюджета',
                expenseType: '622',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '5 160,90',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '5 160,90',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1062',
        credentialName:
          '1062. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки гражданам по установленным критериям нуждаемости (за исключением поддержки льготных категорий граждан))',
        fkrs: [
          {
            fkrCode: '1003',
            fkrName: '1003. Социальное обеспечение населения',
            rows: [
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '7 867,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 227,50',
              },
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '7 558,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 518,00',
              },
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '244',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '7 558,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '7 518,00',
              },
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2020',
                periodType: 'план',
                actualAmount: '566 713,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '523 585,00',
              },
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2021',
                periodType: 'план',
                actualAmount: '544 488,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '544 528,00',
              },
              {
                targetItem: '1539217148. Социальное пособие малоимущим семьям и малоимущим одиноко прожив',
                expenseType: '313',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '126-ОЗ',
                regionalActDetails: 'ст. 12',
                year: '2022',
                periodType: 'план',
                actualAmount: '544 488,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '544 528,00',
              },
            ],
          },
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '58 981,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '58 981,40',
              },
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '57 973,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '57 973,10',
              },
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '57 948,20',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '57 948,20',
              },
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '204-ОЗ',
                regionalActDetails: 'абз. 1 ст. 6',
                year: '2020',
                periodType: 'план',
                actualAmount: '4 141 969,40',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 141 969,40',
              },
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '204-ОЗ',
                regionalActDetails: 'абз. 1 ст. 6',
                year: '2021',
                periodType: 'план',
                actualAmount: '4 071 166,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 071 166,10',
              },
              {
                targetItem: '154P117103. Ежемесячное пособие в соответствии с Законом Свердловской област',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '204-ОЗ',
                regionalActDetails: 'абз. 1 ст. 6',
                year: '2022',
                periodType: 'план',
                actualAmount: '4 071 166,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '4 071 166,10',
              },
            ],
          },
        ],
      },
      {
        credentialCode: '1063',
        credentialName:
          '1063. Социальная поддержка и социальное обслуживание граждан пожилого возраста и инвалидов, граждан, находящихся в трудной жизненной ситуации, а также детей-сирот, безнадзорных детей, детей, оставшихся без попечения родителей (за исключением детей, обучающихся в федеральных образовательных учреждениях), социальной поддержки ветеранов труда, лиц, проработавших в тылу в период Великой Отечественной войны 1941 - 1945 годов, семей, имеющих детей (в том числе многодетных семей, одиноких родителей), жертв политических репрессий, малоимущих граждан, в том числе за счет предоставления субвенций местным бюджетам для выплаты пособий на оплату проезда на общественном транспорте, иных социальных пособий, а также для возмещения расходов муниципальных образований в связи с предоставлением законами субъекта Российской Федерации льгот отдельным категориям граждан, в том числе льгот по оплате услуг связи, организация предоставления гражданам субсидий на оплату жилых помещений и коммунальных услуг (в части предоставления мер социальной поддержки детям-сиротам, безнадзорным детям, детям, оставшимся без попечения родителей)',
        fkrs: [
          {
            fkrCode: '1004',
            fkrName: '1004. Охрана семьи и детства',
            rows: [
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '235,10',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '235,10',
              },
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '313,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '313,00',
              },
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '244',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '480-ПП',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '313,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '313,00',
              },
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '28-ОЗ',
                regionalActDetails: 'ст. 22, ч. 2, п. 5',
                year: '2020',
                periodType: 'план',
                actualAmount: '16 811,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '16 811,00',
              },
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '28-ОЗ',
                regionalActDetails: 'ст. 22, ч. 2, п. 5',
                year: '2021',
                periodType: 'план',
                actualAmount: '22 444,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '22 444,00',
              },
              {
                targetItem:
                  '1542917000. Компенсация стоимости путевки в организации отдыха детей и их оздоровления (в санаторно-курортные организации), расположенные на территории Свердловской области, и проезда к месту лечения (отдыха) и обратно',
                expenseType: '321',
                additionalClassificationCode: '99901',
                federalAct: '184-ФЗ',
                federalActDetails: 'подп. 24 п. 2 ст. 26.3.',
                regionalAct: '28-ОЗ',
                regionalActDetails: 'ст. 22, ч. 2, п. 5',
                year: '2022',
                periodType: 'план',
                actualAmount: '22 444,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '22 444,00',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    grbsCode: '046000',
    grbsName: '046000. Министерство энергетики и жилищно-коммунального хозяйства Свердл',
    credentials: [
      {
        credentialCode: '610005',
        credentialName:
          '610005. Предоставление гражданам, проживающим на территории Свердловской области, меры социальной поддержки по частичному освобождению от платы за коммунальные услуги ',
        fkrs: [
          {
            fkrCode: '0505',
            fkrName: '0505. Другие вопросы в области жилищно-коммунального хозяйства',
            rows: [
              {
                targetItem: '4630842700. Субвенции местным бюджетам на осуществление государственного пол',
                expenseType: '530',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: '1330-ПП ',
                regionalActDetails: 'п. 1',
                year: '2020',
                periodType: 'план',
                actualAmount: '221 909,80',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '221 909,80',
              },
              {
                targetItem: '4630842700. Субвенции местным бюджетам на осуществление государственного пол',
                expenseType: '530',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: '1330-ПП ',
                regionalActDetails: 'п. 1',
                year: '2021',
                periodType: 'план',
                actualAmount: '200 000,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '200 000,00',
              },
              {
                targetItem: '4630842700. Субвенции местным бюджетам на осуществление государственного пол',
                expenseType: '530',
                additionalClassificationCode: '99900',
                federalAct: '184-ФЗ',
                federalActDetails: 'ч. 3 ст. 26.3-1',
                regionalAct: '1330-ПП ',
                regionalActDetails: 'п. 1',
                year: '2022',
                periodType: 'план',
                actualAmount: '275 684,00',
                sourceOfFinancing: 'бюджет субъекта',
                estimationMethod: 'нормативный метод',
                estimatedAmount: '275 684,00',
              },
            ],
          },
        ],
      },
    ],
  },
];
